import React, { useState, useEffect, useContext } from "react";
import getProfileLabel from "../genericFunctions/getProfileLabel";
import { AuthContext } from "../context/AuthContext";
import { useHistory } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import CloseIcon from "@material-ui/icons/Close";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";

const EducationItem = (props) => {
  const updateEducation = props.updateEducation;
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const [editing, setEditing] = useState(false);
  const [education, setEducation] = useState({
    _id: null,
    name: "",
    school: "",
    fromDate: "",
    toDate: "",
    ongoing: false,
  });
  const [ongoing, setOngoing] = useState(false);

  const onChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setEducation({ ...education, [name]: value });
  };

  useEffect(() => {
    if (!authContext.isAuthenticated) {
      history.push("/login");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (editing) {
      setOngoing(props.education.ongoing);
      setEducation({
        _id: props.education._id,
        name: props.education.name,
        school: props.education.school,
        fromDate:
          props.education.fromDate !== null ? props.education.fromDate : null,
        toDate: props.education.toDate !== null ? props.education.toDate : null,
        ongoing: props.education.ongoing,
      });
    }
  }, [editing]); // eslint-disable-line react-hooks/exhaustive-deps

  const validateExperience = () => {
    console.log(education.fromDate < education.toDate);
    if (
      education.name === "" ||
      education.school === "" ||
      education.fromDate === null ||
      ((education.toDate === null ||
        isNaN(Date.parse(education.toDate)) ||
        new Date(education.fromDate) > new Date(education.toDate)) &&
        ongoing === false) ||
      isNaN(Date.parse(education.fromDate))
    ) {
      return false;
    }
    return true;
  };
  useEffect(() => {
    if (education.ongoing) {
      setEducation({ ...education, toDate: null });
    } else if (
      (!education.ongoing && education.toDate === null) ||
      education.toDate.length <= 0
    ) {
      setEducation({ ...education, toDate: new Date() });
    }
  }, [education.ongoing]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Paper
      elevation={1}
      style={{
        margin: "10px 0px",
        padding: "10px",
        display: "flex",
        flexDirection: "column",
        minWidth: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #e1e1e1",
          padding: "5px 5px 5px 0px",
          marginBottom: "15px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <h6
            style={{
              margin: "0",
              marginRight: "10px",
            }}
          >
            {editing
              ? `Editing (${props.education.name})`
              : props.education.name}
          </h6>
          {!editing && (
            <p
              style={{
                fontStyle: "italic",
                color: "dark-grey",
                fontSize: "90%",
                margin: "5px 0px 0px 0px",
              }}
            >{`${
              props.education.fromDate !== null
                ? props.education.fromDate.slice(0, 7)
                : getProfileLabel(props.profileLanguage, "missingDate")
            } - ${
              props.education.toDate !== null
                ? props.education.toDate.slice(0, 7)
                : getProfileLabel(props.profileLanguage, "present")
            }`}</p>
          )}
        </div>
        <div style={{ display: "flex" }}>
          {!editing && (
            <IconButton
              variant="outlined"
              color="primary"
              style={{ justifySelf: "flex-end" }}
              onClick={() => setEditing(true)}
            >
              <EditIcon />
            </IconButton>
          )}
          {editing && (
            <IconButton
              variant="outlined"
              color="primary"
              style={{ justifySelf: "flex-end" }}
              onClick={() => setEditing(false)}
            >
              <CloseIcon />
            </IconButton>
          )}
        </div>
      </div>
      {!editing && (
        <div>
          <p>{props.education.school}</p>
        </div>
      )}
      {editing && (
        <div
          elevation={1}
          style={{
            margin: "5px 0px",
            display: "flex",
            flexDirection: "column",
            minWidth: "45%",
          }}
        >
          <form
            onSubmit={(e) => {
              setEditing(false);
              updateEducation(e, education);
            }}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <TextField
              type="text"
              name="name"
              label="Name"
              value={education.name}
              onChange={onChange}
              style={{ margin: "5px 0px" }}
              variant="outlined"
            />
            <TextField
              type="text"
              name="school"
              label="School"
              value={education.school}
              onChange={onChange}
              variant="outlined"
              style={{ margin: "5px 0px" }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={ongoing}
                  onClick={() => {
                    setOngoing(!ongoing);
                  }}
                  onChange={onChange}
                  name="ongoing"
                  value={ongoing}
                  color="primary"
                />
              }
              label="Ongoing"
              style={{ width: "30.5%", padding: "10px 2px 5px" }}
            />
            <div style={{ display: "flex" }}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-between">
                  <KeyboardDatePicker
                    inputVariant="outlined"
                    disableToolbar
                    variant="inline"
                    format="MM/yyyy"
                    views={["year", "month"]}
                    margin="normal"
                    id="date-picker-inline"
                    InputLabelProps={{ shrink: true }}
                    label="From date"
                    value={education.fromDate}
                    onChange={(date) => {
                      setEducation({ ...education, fromDate: date });
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    style={{ width: "40%" }}
                  />

                  {!education.ongoing && (
                    <KeyboardDatePicker
                      inputVariant="outlined"
                      disableToolbar
                      variant="inline"
                      format="MM/yyyy"
                      views={["year", "month"]}
                      margin="normal"
                      id="date-picker-inline"
                      InputLabelProps={{ shrink: true }}
                      label="To date"
                      value={education.toDate}
                      onChange={(date) => {
                        setEducation({ ...education, toDate: date });
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      style={{ width: "40%" }}
                      disabled={education.ongoing}
                    />
                  )}
                </Grid>
              </MuiPickersUtilsProvider>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "flex", marginTop: "10px" }}>
                <Button
                  disabled={!validateExperience()}
                  type="submit"
                  variant="outlined"
                  color="primary"
                  style={{ marginRight: "10px" }}
                >
                  Save
                </Button>
                <Button
                  type="button"
                  variant="outlined"
                  color="secondary"
                  onClick={() => setEditing(false)}
                >
                  Cancel
                </Button>
              </div>
              <IconButton
                variant="outlined"
                color="secondary"
                style={{ justifySelf: "flex-end" }}
                onClick={() => props.removeEducation(props.education)}
              >
                <DeleteIcon />
              </IconButton>
            </div>
          </form>
        </div>
      )}
    </Paper>
  );
};

export default EducationItem;
